
import router from "@/router";
import { deckService } from "@/services/deck.service";
import { monkeyService } from "@/services/monkey.service";
import { monkeyStore } from "@/store";
import { Monkey } from "monkeybattle-shared";
import { computed, defineComponent, ref } from "vue";
import ImageLoader from "@/components/UI/ImageLoader.vue";

export default defineComponent({
  name: "NewDeck",
  components: {
    ImageLoader,
  },

  setup() {
    const deckName = ref("New Deck");
    monkeyService.updateStoreMonkeys();
    const monkeys = computed(monkeyStore.getters.monkeys);
    const selectedMonkey = ref<Monkey>();

    const selectMonkey = (monkey: Monkey) => (selectedMonkey.value = monkey);

    const createDeck = async () => {
      if (!selectedMonkey.value) return;
      const deck = await deckService.create({
        name: deckName.value,
        monkeyId: selectedMonkey.value.id,
      });

      router.push({ name: "DeckBuilder", params: { deckId: deck.id } });
    };

    return {
      deckName,
      monkeys,
      selectMonkey,
      selectedMonkey,
      createDeck,
    };
  },
});
